import {Directive, HostListener, Input} from '@angular/core';
import {LeavingPageGuardService} from 'app/guards/leaving-page-guard.service';

@Directive({
    selector: 'a[routerLink][externalLink]',
})
export class RouterLinkDirective {
    @Input() routerLink;
    @Input() externalLink = false;

    constructor(private leaving: LeavingPageGuardService) {}

    @HostListener('click', ['$event']) onClick(event: MouseEvent) {
        if (!this.externalLink) {
            return;
        }

        this.leaving.isLeaving = true;
        event.stopPropagation();
        event.stopImmediatePropagation();
        event.preventDefault();

        document.location = this.routerLink;
    }
}
